import moment from "moment";
import { useParams } from "react-router-dom";
import { api } from "../../../..";
import Download from "../../../../Components/Download/Download";
import Utils from "../../../../vendor/weblink/nguc-javascript-client/Utils";
import { intToTime } from "../../../../Components/Global";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../Components/Spinner/Spinner";

const HistoryStatistics = (props:any) => {
    const { id } = useParams();
	const { t } = useTranslation();


	if(props.loading) {
		return <div className="callout">
			<div className="history">
				<span className='spinner-container'>
					<Spinner />
				</span>
			</div>
		</div>
	}

    const capitalize = (s:string) => {
        if(!s) {
            return
        }

        s = s.toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    return <div className="callout">
        <div className="history">
			<div className="header-top-bar">
				<div>
					<b>{t('history_statistics')}</b>
				</div>
				<div>
					<Download
						onChange={(event:any) => {
							api.calls.queue.cdr.download(event.value, {
								'queues[]': id ?? '',
								datetime_from: props.dateFrom ? props.dateFrom : moment().format('YYYY-MM-DD'),
								datetime_to: props.dateTo ? props.dateTo : moment().format('YYYY-MM-DD'),
								limit: 1000
							})
							.then((r:any) => {
								Utils.downloadDataFile(
									t('history')+ '.' + (event.value === 'excel' ? 'xlsx' : event.value),
									new Blob([r.data])
								)
							})
						}}
					/>
				</div>
			</div>
            <div className="row history-data">
                <div className="small-12 medium-12 large-12 columns">
                    <table className="unstriped">
                        <thead>
                            <tr>
                                <th>
                                    <b>{t('agent')}</b>
                                </th>
                                <th>
                                    <b>{t('number')}</b>
                                </th>
                                <th>
                                    <b>{t('wait')}</b>
                                </th>
                                <th>
                                    <b>{t('call_time')}</b>
                                </th>
                                <th>
                                    <b>{t('time')}</b>
                                </th>
                                <th>
                                    <b>{t('status')}</b>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Object.keys(props.queueCdr).length !== 0 && Object.keys(props.users).length !== 0
                                ?
                                    props.queueCdr.map((queue: any) => {
                                        return <tr key={queue.id}>
                                            <td>
                                                {
                                                    queue.pbx_user_id !== null
                                                    ?
                                                        props.users.map((user:any) => {
                                                            if( user.id === queue.pbx_user_id ) {
                                                                return `${user.name} ${user.surname}`;
                                                            }
                                                        })
                                                    :
                                                        ''
                                                }
                                            </td>
                                            <td>
                                                {
                                                    queue.callerid
                                                }
                                            </td>
                                            <td>
                                                {
                                                    queue.wait_time !== null
                                                    ?
                                                        intToTime(parseInt(queue.wait_time))
                                                    :
                                                        '00:00'
                                                }
                                            </td>
                                            <td>
                                                {
                                                    queue.talk_time !== null
                                                    ?
                                                        intToTime(parseInt(queue.talk_time))
                                                    :
                                                        '00:00'
                                                }
                                            </td>
                                            <td>
                                                {
                                                    moment(queue.calldate).format('YYYY-MM-DD HH:mm:ss')?? '00:00'
                                                }
                                            </td>
                                            <td data-tooltip title={queue.reason === "ABANDON" ? "Abandon" : ''}>
                                                {
                                                    queue.disposition === "NOANSWERED" ? capitalize('NOT ANSWERED') : capitalize(queue.disposition)
                                                }
                                            </td>
                                        </tr>
                                    })
                                :
                                    <tr>
                                        <td className="center-text" colSpan={6}>{t('no_data_found')}</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
}

export default HistoryStatistics;
